var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.125C3.74941 1.125 1.125 3.75117 1.125 9C1.125 14.2506 3.74941 16.875 9 16.875C14.2506 16.875 16.875 14.2506 16.875 9C16.875 3.75117 14.2506 1.125 9 1.125ZM11.7229 9.74004C11.4768 10.8369 12.7934 12.5121 12.1395 13.0676C11.4855 13.6248 10.4291 11.6438 9.10371 11.6438C7.77832 11.6438 6.85195 13.6406 6.06797 13.0676C5.28223 12.4945 6.82734 10.7051 6.48457 9.74004C6.48457 8.5623 4.29082 8.55176 4.19238 7.29316C4.09395 6.29473 6.64277 7.37227 7.48652 6.66035C8.56582 3.55957 9.10547 3.7248 9.10547 3.7248C9.87363 3.7248 10.0213 5.84297 10.7244 6.66035C11.7879 7.37227 13.9693 6.3123 14.0186 7.29316C14.066 8.27402 11.9689 8.64492 11.7229 9.74004Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.593f35aabf9003614ec10313bd712757.svg";
export { ForwardRef as ReactComponent };